module.exports = __webpack_public_path__ + "static/img/solution2.d02d97f.png";


//////////////////
// WEBPACK FOOTER
// ./static/moblieHome/solution2.png
// module id = XX2A
// module chunks = 1